var _path, _rect, _path2, _mask, _ellipse, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2C1 1.44772 1.44772 1 2 1H25C25.5523 1 26 1.44772 26 2V17.44C26 17.9923 25.5523 18.44 25 18.44H23.2481C22.3054 18.44 21.4176 18.8831 20.8508 19.6365L18.9708 22.1354L16.8773 19.5515C16.3077 18.8484 15.4512 18.44 14.5463 18.44H2C1.44771 18.44 1 17.9923 1 17.44V2Z",
    stroke: "#717070",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.98047,
    y: 8.57959,
    width: 5.89735,
    height: 6.03985,
    rx: 0.5,
    stroke: "#747272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4617 5.98154L14.5443 7.73713C14.4777 7.86454 14.3732 7.96809 14.2451 8.03343C14.0132 8.1518 13.8672 8.39023 13.8672 8.65064V13.9728C13.8672 14.5251 14.3149 14.9728 14.8672 14.9728H18.6091H20.4771C20.937 14.9728 21.0519 14.3862 21.0519 14.0929V12.9195C21.0998 11.5507 21.1094 8.69563 20.7645 8.22631C20.4197 7.75699 20.0461 7.63966 19.9024 7.63966H18.2696C17.6316 7.63966 17.1615 7.04811 17.1963 6.41107C17.233 5.74062 17.1722 5.23475 17.1722 4.85305C17.1722 4.43814 16.7604 3.57238 16.4332 3.30963C16.3594 3.25031 16.262 3.23916 16.1674 3.2445C15.9874 3.25465 15.6894 3.2865 15.5915 3.38641C15.4798 3.50046 15.5418 4.85623 15.575 5.4535C15.5851 5.6366 15.5466 5.819 15.4617 5.98154Z",
    fill: "#747272"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_2899_361",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5006,
    cy: 10.9202,
    rx: 0.574779,
    ry: 0.586654
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5006,
    cy: 10.9202,
    rx: 0.574779,
    ry: 0.586654,
    fill: "#747272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0753 10.9202C10.0753 10.7112 10.2465 10.5068 10.5006 10.5068V12.5068C11.3895 12.5068 12.0753 11.7771 12.0753 10.9202H10.0753ZM10.5006 10.5068C10.7546 10.5068 10.9258 10.7112 10.9258 10.9202H8.92578C8.92578 11.7771 9.61165 12.5068 10.5006 12.5068V10.5068ZM10.9258 10.9202C10.9258 11.1291 10.7546 11.3335 10.5006 11.3335V9.3335C9.61165 9.3335 8.92578 10.0632 8.92578 10.9202H10.9258ZM10.5006 11.3335C10.2465 11.3335 10.0753 11.1291 10.0753 10.9202H12.0753C12.0753 10.0632 11.3895 9.3335 10.5006 9.3335V11.3335Z",
    fill: "#747272",
    mask: "url(#path-4-inside-1_2899_361)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.4ac3bd1710e394afb187e07904a16926.svg";
export { ForwardRef as ReactComponent };